// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fHrh","largestCol":"styles_largestCol__11iqt","smallestCol":"styles_smallestCol__1PGHe"};